import { Helmet } from 'react-helmet-async';

import DealerRequiredPageShell from 'app/components/ReusableUIComponents/HighLevelComponents/DealerRequiredPageShell';
import { DealerPageHeaderEntityInfo } from 'app/components/ReusableUIComponents/LowLevelComponents/PageHeaderEntityInfo';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import { NurturingJourneySettingsComponent } from 'app/pages/NurturingJourneySettingsComponent/Loadable';
import { CONFIGURE_RESOURCE_NURTURING_JOURNEY } from 'app/pages/ConfigurePage/utils/configureResourceIds';

import { useNurturingJourneySettingsPage } from './hooks/useNurturingJourneySettingsPage';

const NurturingJourneySettingsPage = () => {
  const { breadcrumbsList, hasDealer, dealerTitle, dealerId } =
    useNurturingJourneySettingsPage();

  return (
    <>
      <Helmet>
        <title>Nurturing Journey Settings</title>
        <meta
          name="description"
          content="Configure nurturing journey settings for the selected dealership"
        />
      </Helmet>
      <DealerRequiredPageShell
        hasDealer={hasDealer}
        breadcrumbsList={breadcrumbsList}
        pageTitle="Nurturing Journey Settings"
        headerSubtitle={
          hasDealer ? (
            <DealerPageHeaderEntityInfo
              title={dealerTitle}
              dealerId={dealerId}
            />
          ) : undefined
        }
        contentVariant="centered"
      >
        <NurturingJourneySettingsComponent defaultExpanded />
      </DealerRequiredPageShell>
    </>
  );
};

export default withResourceProtection(
  NurturingJourneySettingsPage,
  CONFIGURE_RESOURCE_NURTURING_JOURNEY,
);
